<nz-row class="form-footer">
  <nz-col nzSpan="24" class="submit-col">
    <ng-container #fieldComponent> </ng-container>
  </nz-col>
</nz-row>
